import React from "react"
import * as styles from "./title-page.module.scss"
import { TitleBlockFieldsFragment } from "../../../graphql-types"
import { ReactSVG } from "react-svg"
import { configureSVGAccessibility } from "../../utils/accessibility"
type RenderProps = {
  titleData: TitleBlockFieldsFragment
  locale: string
  locales: string[]
}

const TitlePage: React.FC<RenderProps> = ({ titleData, locale, locales }) => {
  function getTextOrImageClass(titleBlock) {
    if (!titleBlock.textOrImage) {
      if (titleBlock.linkText) {
        return styles.titleBlockItem + " " + styles.titleText
      }
    } else if (titleBlock.textOrImage && titleBlock.linkImage) {
      return styles.titleBlockItem + " " + styles.titleImage
    }
    return styles.titleBlockItem + " " + styles.titleText
  }

  function getTextOrImageLayout(titleBlock) {
    if ((!titleBlock.linkText && !titleBlock.linkImage) || (!titleBlock.textOrImage && !titleBlock.linkText)) {
      return <div className={styles.ticketBlockText}>{titleBlock.title}</div>
    }
    if (!titleBlock.textOrImage && titleBlock.linkText) {
      return <div className={styles.ticketBlockText}>{titleBlock.linkText}</div>
    }
    if (titleBlock.textOrImage && titleBlock.linkImage) {
      return (
        <div>
          {titleBlock.linkImage.format === "svg" ? (
            <ReactSVG
              src={titleBlock.linkImage.url}
              className={styles.svgImage}
              beforeInjection={svg => configureSVGAccessibility(svg, titleBlock.linkImage.alt || "")}
            />
          ) : (
            <img src={titleBlock.linkImage.url} alt={titleBlock.linkImage.alt || ""} className={styles.image} />
          )}
        </div>
      )
    }
  }

  return (
    <ul className={styles.titleRow}>
      {titleData.titleBlockLink.map(titleBlock => {
        return (
          <li key={titleBlock.id}>
            <a
              href={
                !titleBlock.externalLink && !titleBlock.internalLink
                  ? "#"
                  : titleBlock.externalLink
                    ? titleBlock.externalLink
                    : titleBlock.internalLink && titleBlock.internalLink.__typename == "DatoCmsPage"
                      ? locale === locales[0]
                        ? "/" + titleBlock.internalLink.slug
                        : "/" + locale + "/" + titleBlock.internalLink.slug
                      : "/"
              }
              className={getTextOrImageClass(titleBlock)}
              key={titleBlock.id}
            >
              {getTextOrImageLayout(titleBlock)}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export default TitlePage
